 /* eslint-disable */
export default class UserToken {
  constructor() {
    this.tokens = JSON.parse(localStorage.getItem('playToken') || '{}');
    this.revisions = JSON.parse(localStorage.getItem('revisions') || '{}');
    this.accountTokens = JSON.parse(localStorage.getItem('audienceQAToken') || '{}');
    this.voterId = localStorage.getItem('voterId');
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  getRevision(pollId) {
    return this.revisions[pollId];
  }

  clearTokens(pollId) {
    delete this.tokens[pollId];
    delete this.revisions[pollId];
    localStorage.setItem('playToken', JSON.stringify(this.tokens));
    localStorage.setItem('revisions', JSON.stringify(this.revisions));
  }

  setRevision(pollId, revision = 0) {
    this.revisions[pollId] = revision;
    localStorage.setItem('revisions', JSON.stringify(this.revisions));
  }

  getByPollId(pollId, revision = 0) {
    if (!this.tokens[pollId]) {
      this.tokens[pollId] = this.voterId || this.uuidv4();
      localStorage.setItem('playToken', JSON.stringify(this.tokens));
      this.setRevision(pollId, revision);
    }

    return this.tokens[pollId];
  }
  getByPollIdIfExists(pollId) {
    console.log('this.tokens', this.tokens, pollId);
    return this.tokens[pollId];
  }

  getByAccountName(accountName) {
    if (!this.accountTokens[accountName]) {
      this.accountTokens[accountName] = this.uuidv4();
      localStorage.setItem('audienceQAToken', JSON.stringify(this.accountTokens));
    }

    return this.accountTokens[accountName];
  }
}
